module.exports = __webpack_public_path__ + "static/media/surprise.cd676b4.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active/snail/nyf/mp3/surprise.mp3
// module id = ZjPy
// module chunks = 1 12